import React, { useEffect, useState } from 'react';
import { Header, SignUpForm } from 'widgets';
import { accessTokenStore, userStore } from 'entities/index';
import { Loading } from 'pages/loading/ui/loading.page';
import { observer } from 'mobx-react';
import { useNavigate } from 'react-router-dom';
import { PageLayout } from 'shared/ui';

export const SignUpPage: React.FC = observer(() => {
  const [isReady, setIsReady] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (accessTokenStore.isAuth) {
      userStore.redirectToRoleBasedPage(navigate);
    }
    setIsReady(true);
  }, [accessTokenStore.isAuth, navigate]);

  if (!isReady) {
    return <Loading />;
  }

  return (
    <PageLayout>
      <Header hideSignUpButton />
      <SignUpForm></SignUpForm>
    </PageLayout>
  );
});
